import { Roles } from "@serie3/common/config/RoleRights";

const useSuperAdmin = () => {
  try {
    const roles = JSON.parse(localStorage.getItem("roles") ?? "[]");
    return Array.isArray(roles) && roles.includes(Roles.SUPER_ADMIN);
  } catch {
    return false;
  }
};

export default useSuperAdmin;
